import { render, staticRenderFns } from "./CResizable.vue?vue&type=template&id=4a422a02&scoped=true"
import script from "./CResizable.vue?vue&type=script&setup=true&lang=js"
export * from "./CResizable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CResizable.vue?vue&type=style&index=0&id=4a422a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a422a02",
  null
  
)

export default component.exports